module.exports = __webpack_public_path__ + "media/images/top/new_item_t-369939069a60bf26aa73332fdc14bb32.gif";